import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=f6c9f392"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c9f392')) {
      api.createRecord('f6c9f392', component.options)
    } else {
      api.reload('f6c9f392', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=f6c9f392", function () {
      api.rerender('f6c9f392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminders/documents/Email.vue"
export default component.exports